import axios, { AxiosError, AxiosResponse } from "axios";
import { IBuxtonSupportTeamMember, IServiceResult } from "../../Models/Models";
import { ICompanySupportTeamAxios } from "../ICompanySupportTeamAxios";

export class CompanySupportTeamAxios implements ICompanySupportTeamAxios {
    public GetCompanySupportTeam(): Promise<
    IServiceResult<Array<IBuxtonSupportTeamMember>>
    > {
        const promise = new Promise<
      IServiceResult<Array<IBuxtonSupportTeamMember>>
    >((resolve, reject) => {
        axios
            .get<IServiceResult<Array<IBuxtonSupportTeamMember>>>(
                "/Common/AccountTeam"
            )
            .then(
                (response: AxiosResponse) => {
                    resolve(response.data);
                },
                (error: AxiosError) => {
                    reject(error);
                }
            );
    });

        return promise;
    }
}
